var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03547 9.28418H0V12.8619C0 15.4416 2.09874 17.5403 4.67849 17.5403C6.76942 17.5403 8.54425 16.1615 9.14181 14.2653C6.45048 14.0821 4.28398 11.9573 4.03547 9.28418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03547 8.25614C4.28398 5.583 6.45048 3.45819 9.14177 3.27498C8.54425 1.37884 6.76942 0 4.67846 0C2.09874 0 0 2.09874 0 4.67846V8.25614H4.03547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51945 4.29004C7.04892 4.29004 5.03894 6.29998 5.03894 8.77052C5.03894 11.2411 7.04888 13.251 9.51945 13.251C11.99 13.251 13.9999 11.2411 13.9999 8.77052C13.9999 6.29998 11.99 4.29004 9.51945 4.29004ZM11.9628 9.28439H10.0333V11.2139H9.00559V9.28439H7.07608V8.25665H9.00559V6.32715H10.0333V8.25665H11.9628V9.28439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.cbfe7fca4b6350b2683ec223a1c23f0d.svg";
export { ForwardRef as ReactComponent };